import { redirect } from '@tanstack/react-router';

import type { IMyRouterContext } from '../__root';

interface IAccountAuthGuardOptions {
  context: IMyRouterContext;
}

export function accountAuthGuard({ context }: IAccountAuthGuardOptions): void {
  if (!context.user) {
    throw redirect({ to: '/' });
  }
}
